import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import './CSS/Register.css';

class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      aatNumber: '',
      prefixTH: '',
      nameTH: '',
      lastNameTH: '',
      prefixEN: '',
      nameEN: '',
      lastNameEN: '',
      gender: '',
      dobDay: '',
      dobMonth: '',
      dobYear: '',
      email: '',
      password: '',
      confirmPassword: '',
      dojo: '',
      address: '',
      phone: '',
      bioPage: null,
      bioLookup: '',
      errorMessage: '',
      successMessage: ''
    };
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value, errorMessage: '', successMessage: '' }, () => {
      if (['aatNumber', 'nameEN', 'lastNameEN'].includes(name)) {
        clearTimeout(this.lookupTimer);
        this.lookupTimer = setTimeout(this.findBioPage, 500);
      }
    });
  };

  componentWillUnmount() {
    clearTimeout(this.lookupTimer);
  }

  // the bio page is found from the AAT number + English name, never typed by the member
  findBioPage = async () => {
    const { aatNumber, nameEN, lastNameEN } = this.state;

    if (!aatNumber.trim() || !nameEN.trim() || !lastNameEN.trim()) {
      this.setState({ bioPage: null, bioLookup: '' });
      return;
    }

    try {
      const query = new URLSearchParams({ aat: aatNumber, name_en: nameEN, last_name_en: lastNameEN });
      const res = await fetch(`/api/find-bio?${query}`);
      const data = await res.json();
      this.setState(res.ok ? { bioPage: data, bioLookup: 'found' } : { bioPage: null, bioLookup: 'notfound' });
    } catch (err) {
      this.setState({ bioPage: null, bioLookup: '' });
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    const {
      aatNumber,
      prefixTH,
      nameTH,
      lastNameTH,
      prefixEN,
      nameEN,
      lastNameEN,
      gender,
      dobDay,
      dobMonth,
      dobYear,
      email,
      password,
      confirmPassword,
      dojo,
      address,
      phone
    } = this.state;

    const requiredFields = [
      aatNumber,
      prefixTH,
      nameTH,
      lastNameTH,
      prefixEN,
      nameEN,
      lastNameEN,
      gender,
      dobDay,
      dobMonth,
      dobYear,
      email,
      password,
      confirmPassword,
      dojo,
      address,
      phone
    ];

    if (!requiredFields.every(f => f.trim() !== '')) {
      this.setState({ errorMessage: 'กรุณากรอกข้อมูลให้ครบถ้วน / Please fill in all required fields.' });
      return;
    }

    if (password !== confirmPassword) {
      this.setState({ errorMessage: 'รหัสผ่านไม่ตรงกัน / Passwords do not match.' });
      return;
    }

    const date_of_birth = `${dobYear}-${dobMonth.padStart(2, '0')}-${dobDay.padStart(2, '0')}`;

    try {
      const response = await fetch('/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          aat_number: aatNumber,
          prefix_th: prefixTH,
          name_th: nameTH,
          last_name_th: lastNameTH,
          prefix_en: prefixEN,
          name_en: nameEN,
          last_name_en: lastNameEN,
          gender,
          date_of_birth,
          email: email.toLowerCase(),
          password,
          dojo,
          address,
          phone
        })
      });

      const data = await response.json();

      if (response.status === 201) {
        // logged in straight away, same as Login.js
        localStorage.removeItem('balance');
        localStorage.removeItem('bioToken');
        localStorage.setItem('email', data.user.email);
        localStorage.setItem('userId', data.user.id);
        localStorage.setItem('bio_slug', data.user.bio_slug);
        localStorage.setItem('bio_url', data.user.bio_url);
        if (data.user.balance !== undefined) {
          localStorage.setItem('balance', String(data.user.balance));
        }
        if (data.bioToken) {
          localStorage.setItem('bioToken', data.bioToken);
        }

        this.setState({
          successMessage: 'Registration successful! Opening your bio page...',
          errorMessage: ''
        });
        setTimeout(() => this.props.history.push(data.redirectUrl), 2000);
      } else {
        this.setState({
          errorMessage: data.message || 'Registration failed!'
        });
      }
    } catch (err) {
      console.error(err);
      this.setState({
        errorMessage: 'An error occurred during registration.'
      });
    }
  };

  renderDayOptions = () =>
    Array.from({ length: 31 }, (_, i) => (
      <option key={i + 1} value={i + 1}>{i + 1}</option>
    ));

  renderMonthOptions = () =>
    [
      'January','February','March','April','May','June',
      'July','August','September','October','November','December'
    ].map((month, i) => (
      <option key={i + 1} value={i + 1}>{month}</option>
    ));

  renderYearOptions = () => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: 100 }, (_, i) => {
      const year = currentYear - i;
      return <option key={year} value={year}>{year}</option>;
    });
  };

  render() {
    return (
      <div className="register-container d-flex align-items-center justify-content-center">
        <div className="text-center">
          <img className="logo" src={logo} alt="Logo" />
          <br />
          <div><Link to="/">Home</Link></div>
          <br />
          <div>Please proceed to registration...</div>
          <br />

          <div className="row justify-content-center">
            <div className="col-sm-8">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={this.handleSubmit}>

                    <h5 className="mb-3">ข้อมูลสมาชิก (ภาษาไทย)</h5>

                    <div className="form-group">
                      <label>คำนำหน้า</label>
                      <input type="text" name="prefixTH" className="form-control"
                        value={this.state.prefixTH} onChange={this.handleInputChange} required />
                    </div>

                    <div className="form-group">
                      <label>ชื่อ</label>
                      <input type="text" name="nameTH" className="form-control"
                        value={this.state.nameTH} onChange={this.handleInputChange} required />
                    </div>

                    <div className="form-group">
                      <label>นามสกุล</label>
                      <input type="text" name="lastNameTH" className="form-control"
                        value={this.state.lastNameTH} onChange={this.handleInputChange} required />
                    </div>

                    <hr />

                    <h5 className="mb-3">Member Information (English)</h5>

                    <div className="form-group">
                      <label>Prefix</label>
                      <input type="text" name="prefixEN" className="form-control"
                        value={this.state.prefixEN} onChange={this.handleInputChange} required />
                    </div>

                    <div className="form-group">
                      <label>First Name</label>
                      <input type="text" name="nameEN" className="form-control"
                        value={this.state.nameEN} onChange={this.handleInputChange} required />
                    </div>

                    <div className="form-group">
                      <label>Last Name</label>
                      <input type="text" name="lastNameEN" className="form-control"
                        value={this.state.lastNameEN} onChange={this.handleInputChange} required />
                    </div>

                    <hr />

                    <div className="form-group">
                      <label>AAT Number</label>
                      <input type="text" name="aatNumber" className="form-control"
                        value={this.state.aatNumber} onChange={this.handleInputChange} required />
                    </div>

                    <div className="form-group">
                      <label>Dojo</label>
                      <input type="text" name="dojo" className="form-control"
                        value={this.state.dojo} onChange={this.handleInputChange} required />
                    </div>

                    <div className="form-group">
                      <label>Address</label>
                      <textarea name="address" className="form-control" rows="3"
                        value={this.state.address} onChange={this.handleInputChange} required />
                    </div>

                    <div className="form-group">
                      <label>Phone</label>
                      <input type="tel" name="phone" className="form-control"
                        value={this.state.phone} onChange={this.handleInputChange} required />
                    </div>

                    {this.state.bioLookup === 'found' && (
                      <div className="alert alert-success">
                        Your bio page: <strong>{this.state.bioPage.title}</strong> ({this.state.bioPage.url})
                      </div>
                    )}
                    {this.state.bioLookup === 'notfound' && (
                      <div className="alert alert-warning">
                        ไม่พบหน้าประวัติของคุณ กรุณาตรวจสอบหมายเลข AAT และชื่อภาษาอังกฤษ /
                        We could not find your bio page. Please check your AAT number and English name.
                      </div>
                    )}

                    <div className="form-group">
                      <label>Gender</label>
                      <select className="form-control" name="gender"
                        value={this.state.gender} onChange={this.handleInputChange} required>
                        <option value="">Select</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Others">Others</option>
                      </select>
                    </div>

                    <div className="form-group">
                      <label>Date of Birth</label>
                      <div className="d-flex gap-2">
                        <select className="form-control" name="dobDay"
                          value={this.state.dobDay} onChange={this.handleInputChange} required>
                          <option value="">Day</option>
                          {this.renderDayOptions()}
                        </select>
                        <select className="form-control" name="dobMonth"
                          value={this.state.dobMonth} onChange={this.handleInputChange} required>
                          <option value="">Month</option>
                          {this.renderMonthOptions()}
                        </select>
                        <select className="form-control" name="dobYear"
                          value={this.state.dobYear} onChange={this.handleInputChange} required>
                          <option value="">Year</option>
                          {this.renderYearOptions()}
                        </select>
                      </div>
                    </div>

                    <div className="form-group mt-3">
                      <label>Email</label>
                      <input type="email" name="email" className="form-control"
                        value={this.state.email} onChange={this.handleInputChange} required />
                    </div>

                    <div className="form-group mt-3">
                      <label>Password</label>
                      <input type="password" name="password" className="form-control"
                        value={this.state.password} onChange={this.handleInputChange} required />
                    </div>

                    <div className="form-group mt-3">
                      <label>Confirm Password</label>
                      <input type="password" name="confirmPassword" className="form-control"
                        value={this.state.confirmPassword} onChange={this.handleInputChange} required />
                    </div>

                    {this.state.errorMessage && <div className="alert alert-danger mt-2">{this.state.errorMessage}</div>}
                    {this.state.successMessage && <div className="alert alert-success mt-2">{this.state.successMessage}</div>}

                    <button type="submit" className="btn btn-dark mt-3">Register</button>
                  </form>

                  <div className="mt-3">Powered by</div>
                  <img className="logo2" src={logo2} alt="Logo 2" />
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    );
  }
}

export default Register;
